import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import {TrackingContext} from '@homeaway/react-event-tracking';

import './ListYourProperty.less';
import {namedEvents, linkLocations} from '../../utils/edap';
import {edapTrigger} from '../../utils/triggerEdap';

function ListYourProperty({isInverse, link, text, displayDesktopTray}) {
    // Add the context to be used for pushing edap events
    const context = useContext(TrackingContext);
    const className = classNames(
        'site-header-list-your-property',
        'btn', 'btn-default', 'btn-sm', {
            'btn-inverse': isInverse,
            'site-header-list-your-property--with-desktop-tray': displayDesktopTray
        });

    const attrs = {
        className,
        'data-bypass': true,
        href: link,
    };

    function handleClickLYP() {
        const fields = {
            actionlocation: linkLocations.HEADER_LINK_LYP
        };
        context.trigger(namedEvents.HEADER_LINK_CLICK, fields);
        edapTrigger(namedEvents.CTA_SELECTED, {action_location: fields.actionlocation, event_action: namedEvents.CTA_BUTTON_CLICKED});
    }

    return (
        // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
        <a {...attrs} target="_blank" onClick={handleClickLYP}>{text}</a>
    );
}

ListYourProperty.propTypes = {
    isInverse: PropTypes.bool,
    text: PropTypes.string.isRequired,
    displayDesktopTray: PropTypes.bool
};

ListYourProperty.defaultProps = {
    isInverse: false,
    displayDesktopTray: false
};

export {ListYourProperty};
